/**
 * The "Team Reports" menu — team-level reporting for managers. See
 * lib/navigation/nav-manifest.js for the entry shape and the vocabulary
 * `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const REPORT_ITEMS = [
  {
    href: "/workspaces/reports",
    label: "All Reports",
    shortcut: "R",
    iconName: "IoBarChartOutline",
  },
  {
    href: "/workspaces/reports/manager-dashboard",
    label: "Manager Dashboard",
    iconName: "IoStatsChartOutline",
    requires: "supervisorOrAbove",
  },
  {
    label: "Practice",
    iconName: "LiaTheaterMasksSolid",
    subItems: [
      {
        href: "/workspaces/reports/discovery",
        label: "Discovery",
        iconName: "CiMap",
        requires: "reportModule",
      },
      {
        href: "/workspaces/reports/pitch",
        label: "Messaging / Pitch",
        iconName: "HiOutlinePresentationChartBar",
        requires: "reportModule",
      },
      {
        href: "/workspaces/reports/objections",
        label: "Objections",
        iconName: "HiNoSymbol",
        requires: "reportModule",
      },
      {
        href: "/workspaces/reports/cold-call",
        label: "Outbound & Inbounds",
        iconName: "IoCallOutline",
        requires: "reportModule",
      },
      {
        href: "/workspaces/reports/plays",
        label: "Plays",
        iconName: "LiaTheaterMasksSolid",
        requires: "reportModule",
      },
      {
        href: "/workspaces/reports/management",
        label: "Management Practice",
        iconName: "HiOutlineUserGroup",
        requires: "reportModule",
      },
    ],
  },
  {
    label: "Execution",
    iconName: "IoFlashOutline",
    // The module-usage report below carries no gate of its own, so this group
    // decides whether the studio does any execution work at all.
    requires: { any: ["dealClinic", "conversationAnalysis"] },
    subItems: [
      {
        href: "/dem-cog/reports",
        label: "Deal Clinic",
        iconName: "IoBarChartOutline",
        requires: "dealClinic",
      },
      {
        href: "/workspaces/reports/execution",
        label: "Execution",
        iconName: "IoFlashOutline",
      },
      {
        href: "/workspaces/reports/transcript-results",
        label: "Conversation Analysis",
        iconName: "IoStatsChartOutline",
        requires: "reportModule",
      },
    ],
  },
  {
    label: "Engagement",
    iconName: "IoTimeOutline",
    subItems: [
      {
        href: "/workspaces/reports/engagement/quarterly",
        label: "By Quarter",
        iconName: "IoTimeOutline",
      },
      {
        href: "/workspaces/reports/engagement/monthly",
        label: "By Month",
        iconName: "IoTimeOutline",
      },
      {
        href: "/workspaces/reports/engagement/weekly",
        label: "By Week",
        iconName: "IoTimeOutline",
      },
      {
        href: "/workspaces/reports/engagement/custom",
        label: "By Date Range",
        iconName: "IoTimeOutline",
      },
      {
        href: "/workspaces/reports/enrollments",
        label: "LP Enrollments",
        iconName: "SlGraduation",
      },
      {
        href: "/workspaces/reports/overdue-items",
        label: "Overdue Items",
        iconName: "CiCircleAlert",
      },
    ],
  },
  {
    label: "Tests",
    iconName: "IoDocumentTextOutline",
    subItems: [
      {
        href: "/workspaces/reports/tests/multiple-choice",
        label: "Multiple Choice",
        iconName: "IoDocumentTextOutline",
      },
      {
        href: "/workspaces/reports/tests/faq",
        label: "Q&A Tests",
        iconName: "IoHelpCircleOutline",
      },
      {
        href: "/workspaces/reports/tests/glossary",
        label: "Glossary Tests",
        iconName: "IoBookOutline",
      },
    ],
  },
  {
    label: "Coaching",
    iconName: "IoStatsChartOutline",
    subItems: [
      {
        href: "/workspaces/reports/recordings",
        label: "Recordings",
        iconName: "IoDocumentTextOutline",
      },
      {
        href: "/workspaces/reports/coaching-report",
        label: "Coaching Report",
        iconName: "IoStatsChartOutline",
      },
      {
        href: "/workspaces/reports/team-coaching",
        label: "Team Coaching",
        iconName: "HiOutlineUserGroup",
      },
      {
        href: "/workspaces/reports/feedback-comments",
        label: "Feedback Comments",
        iconName: "IoChatbubbleOutline",
      },
      {
        href: "/workspaces/reports/practice-sessions-export",
        label: "Sessions Export",
        iconName: "IoDownloadOutline",
      },
    ],
  },
];
